function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e6e6e;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.25 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M19.607,3.536H17.679V2.25H16.393V3.536H6.107V2.25H4.821V3.536H2.893l-.643.643V19.607l.643.643H19.607l.643-.643V4.179Zm-.643,15.429H3.536V7.393H18.964Zm0-12.857H3.536V4.821H18.964ZM6.107,11.25H4.821v1.286H6.107ZM4.821,13.821H6.107v1.286H4.821Zm1.286,2.571H4.821v1.286H6.107ZM8.679,11.25H9.964v1.286H8.679Zm1.286,2.571H8.679v1.286H9.964ZM8.679,16.393H9.964v1.286H8.679ZM9.964,8.679H8.679V9.964H9.964Zm2.571,2.571h1.286v1.286H12.536Zm1.286,2.571H12.536v1.286h1.286Zm-1.286,2.571h1.286v1.286H12.536Zm1.286-7.714H12.536V9.964h1.286Zm2.571,2.571h1.286v1.286H16.393Zm1.286,2.571H16.393v1.286h1.286ZM16.393,8.679h1.286V9.964H16.393Z"
}));

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.6a87f924.svg";
export { ForwardRef as ReactComponent };